// extracted by mini-css-extract-plugin
module.exports = {"phone":"contacte_phone__EMR_m","correu":"contacte_correu__GgD8K","link":"contacte_link__gqBBn","squareList":"contacte_squareList__4JVG_"};